// extracted by mini-css-extract-plugin
export default {"ModeratorListItem":"bek_a bik_a bik_r bik_j","ModeratorListItem__left":"bek_b bik_a bik_j"};